var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({ref:"el",staticClass:"omapi-button omapi-wizard-forward omapi-button__green",attrs:{"type":"submit","disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }